var _excluded = ["topSpace", "rightSpace", "bottomSpace", "leftSpace", "topUnit", "rightUnit", "bottomUnit", "leftUnit", "hasForcedFullWidth", "hasNoReset", "children", "role"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import PushStyles from "../../../helpers/PushStyles";
var StyledPushOrg = styled.div.withConfig({
  componentId: "sc-u6u06y-0"
})(function (_ref) {
  var $topSpace = _ref.$topSpace,
    $rightSpace = _ref.$rightSpace,
    $bottomSpace = _ref.$bottomSpace,
    $leftSpace = _ref.$leftSpace,
    $topUnit = _ref.$topUnit,
    $rightUnit = _ref.$rightUnit,
    $bottomUnit = _ref.$bottomUnit,
    $leftUnit = _ref.$leftUnit,
    $hasForcedFullWidth = _ref.$hasForcedFullWidth,
    $hasNoReset = _ref.$hasNoReset;
  return css(["", ";", ";", ";"], PushStyles({
    top: $topSpace,
    right: $rightSpace,
    bottom: $bottomSpace,
    left: $leftSpace
  }, $hasNoReset, "space", "margin"), PushStyles({
    top: $topUnit,
    right: $rightUnit,
    bottom: $bottomUnit,
    left: $leftUnit
  }, $hasNoReset, "unit", "margin"), $hasForcedFullWidth && css(["width:100%;"]));
});
function PushOrg(_ref2) {
  var topSpace = _ref2.topSpace,
    rightSpace = _ref2.rightSpace,
    bottomSpace = _ref2.bottomSpace,
    leftSpace = _ref2.leftSpace,
    topUnit = _ref2.topUnit,
    rightUnit = _ref2.rightUnit,
    bottomUnit = _ref2.bottomUnit,
    leftUnit = _ref2.leftUnit,
    hasForcedFullWidth = _ref2.hasForcedFullWidth,
    hasNoReset = _ref2.hasNoReset,
    children = _ref2.children,
    role = _ref2.role,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledPushOrg, _extends({
    $topSpace: topSpace,
    $rightSpace: rightSpace,
    $bottomSpace: bottomSpace,
    $leftSpace: leftSpace,
    $topUnit: topUnit,
    $rightUnit: rightUnit,
    $bottomUnit: bottomUnit,
    $leftUnit: leftUnit,
    $hasForcedFullWidth: !!hasForcedFullWidth,
    $hasNoReset: !!hasNoReset,
    role: role
  }, restProps), children);
}
export default PushOrg;